import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useAuth } from "./helpers/configs/plugins/CookieAuthPlugin";
import { IS_APP_PRODUCTION, PACKAGE_NAME } from "./helpers/flavor/app";
import BasePage from "./view/app";
import AuthPage from "./view/auth";
import PrivacyPolicy from "./view/pages/PrivacyPolicy";

export default function Routes() {
  const { user } = useAuth();
  return (
    <BrowserRouter basename={IS_APP_PRODUCTION ? `/` : PACKAGE_NAME}>
      <Switch>
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        {user ? <Redirect from="/login" to="/" /> : <AuthPage />}
        {user ? <BasePage /> : <Redirect to="/login" />}
      </Switch>
    </BrowserRouter>
  );
}
